import { RedirectButtonIntialStateProps } from 'utils';

export const redirectButtonInitial: RedirectButtonIntialStateProps = {
    sitIdValue: '',
    redirectFromValue: '',
    redirectUrlValue: '',
};
